import { adsDestinationEnabled } from './analytics';

// GOOGLE_ANALYTICS_ID is set by the Rails view in _google_analytics.html.slim
if (window.GOOGLE_ANALYTICS_ID) {
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());

  // Turbo Drive is disabled (see application.js), so every navigation is a full load and the
  // default page_view from config fires on each one — no turbo:load page_view needed.
  const config = {};
  if (window.GOOGLE_ANALYTICS_USER_ID) {
    config.user_id = window.GOOGLE_ANALYTICS_USER_ID;
  }
  // Browser-read, not server-rendered: lite's HTML is one CDN-cached object shared by every visitor.
  // Catdoms only — GA4 reads campaign and click params out of page_location (UNS-5209).
  const scrub = window.AnalyticsUrlScrubber.catdoms;
  config.page_location = scrub(window.location.href);
  // Unset rather than '' so gtag falls back to its own handling.
  if (document.referrer) {
    config.page_referrer = scrub(document.referrer);
  }
  window.gtag('config', window.GOOGLE_ANALYTICS_ID, config);

  // Conversion measurement only; drop the flag to allow remarketing. page_location is passed again
  // because config params are per destination.
  if (adsDestinationEnabled()) {
    window.gtag('config', window.GOOGLE_ADS_CONVERSION_ID, {
      page_location: config.page_location,
      allow_ad_personalization_signals: false,
    });
  }
}
